module.exports = __webpack_public_path__ + "static/media/REMAN-SLIDE-5.a45bd6be.png";